/**
 * @fileoverview パスワードリセットAPI
 *
 * このファイルでは、パスワードリセットプロセスの最終段階として
 * 新しいパスワードを設定するためのAPI連携機能を提供します。
 */

/**
 * パスワードをリセットする
 *
 * リセットトークンと新しいパスワードを使用して、ユーザーのパスワードを
 * リセット（更新）します。パスワードリセットプロセスの最終ステップで、
 * 新しいパスワードをシステムに登録します。
 *
 * @param {string} token - パスワードリセット用の検証トークン
 * @param {string} newPassword - 設定する新しいパスワード
 * @returns {Promise<void>} パスワードリセット成功を示すPromise
 * @throws {Error} パスワードリセット失敗やAPI通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

export const resetPassword = async (
  resetSessionId: string,
  newPassword: string
) => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;

  const res = await fetchWithLog(`${bffOrigin}/v1/password/reset/confirm`, {
    method: "POST",
    body: JSON.stringify({
      reset_session_id: resetSessionId,
      new_password: newPassword,
    }),
  });

  if (!res.ok) {
    console.error("Failed to reset password.");
    throw new Error("Failed to reset password.");
  }
};
